import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Three years of unbroken supply. Their 8mm+ grade has become the standard for our biryani at all 14 of our properties. Zero quality drift.",
    name: "Arvind Menon",
    role: "Procurement Head, Hospitality Group",
    location: "Bangalore",
    rating: 5,
  },
  {
    quote:
      "We private-label cardamom across South India. ELA Traders' grading consistency and lab certification let us scale without worry.",
    name: "Priya Ranganathan",
    role: "Founder, Spice House Brand",
    location: "Indiranagar",
    rating: 5,
  },
  {
    quote:
      "Pricing is fair, aroma is unmatched, delivery is always on time. Our mithai customers can tell the difference instantly.",
    name: "Mohan Iyer",
    role: "Owner, Heritage Sweet Mart",
    location: "Malleshwaram",
    rating: 5,
  },
  {
    quote:
      "From a 25 kg trial order to monthly container-loads — they grew with us. The Kerala-direct supply story is the real deal.",
    name: "Sundar Rao",
    role: "Director, Food Manufacturing Co.",
    location: "Bommasandra",
    rating: 5,
  },
];

export const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = TESTIMONIALS[active];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section-pad bg-[#FAF8F2] relative"
    >
      <div className="container-luxury">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="heading-eyebrow justify-center">
            <span className="line" />
            <span className="text">Trusted Voices</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-[#0E4D3D] leading-tight">
            What buyers say.
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <Quote
              className="absolute -top-8 left-0 text-[#C9A227]/15 w-32 h-32"
              strokeWidth={0.6}
            />

            <AnimatePresence mode="wait">
              <motion.div
                key={active}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                className="relative z-10"
              >
                <div className="flex gap-1 mb-6">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 fill-[#C9A227] text-[#C9A227]"
                    />
                  ))}
                </div>
                <p
                  className="font-serif text-[#0E4D3D] text-xl md:text-3xl leading-snug italic"
                  data-testid="testimonial-quote"
                >
                  "{t.quote}"
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-[#0E4D3D] flex items-center justify-center font-serif text-[#C9A227] text-lg">
                    {t.name.split(" ").map((n) => n[0]).join("")}
                  </div>
                  <div>
                    <div className="font-serif text-[#0E4D3D] text-lg">{t.name}</div>
                    <div className="text-[#4A4A4A] text-sm font-light">
                      {t.role} · {t.location}
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Controls */}
          <div className="mt-12 flex items-center justify-between">
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  data-testid={`testimonial-dot-${i}`}
                  className={`h-px transition-all duration-500 ${
                    i === active ? "w-12 bg-[#C9A227]" : "w-6 bg-[#0E4D3D]/20"
                  }`}
                  aria-label={`Testimonial ${i + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-3">
              <button
                onClick={() =>
                  setActive((p) =>
                    p === 0 ? TESTIMONIALS.length - 1 : p - 1
                  )
                }
                data-testid="testimonial-prev"
                className="w-12 h-12 border border-[#0E4D3D]/20 hover:border-[#C9A227] hover:text-[#C9A227] transition-colors flex items-center justify-center"
                aria-label="Previous"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button
                onClick={() =>
                  setActive((p) => (p + 1) % TESTIMONIALS.length)
                }
                data-testid="testimonial-next"
                className="w-12 h-12 bg-[#0E4D3D] text-white hover:bg-[#C9A227] hover:text-[#0E4D3D] transition-colors flex items-center justify-center"
                aria-label="Next"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
